exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#section-hero{position:sticky;position:-webkit-sticky;top:0;z-index:5}#canvas-hero{padding:.7%}.canvas-layer{max-width:100%;height:auto}.canvas-drawable{position:absolute;left:0;top:0}#canvas-hero svg{position:absolute;top:1vh;right:1vh;font-size:3.3vw;cursor:pointer;z-index:1000}.lightsoff{background-color:#000;color:#fff}.lightson{background-color:#dad8d8;color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-06875145","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PreviewArea.vue
// module id = 129
// module chunks = 0